export default function ToggleButton(options = {}){
    if(!options.container){
        console.error('ToggleButton: "container" is required');
        throw('Erro')
    }
    BaseConstructor.call(this)
    let button_element = document.createElement('button')
    let button_class = options.custom_class || ""
    let container = options.container //element ou selector
    
    let show_icon = options.show_icon
    let states = options.states || [] //ex: {title: teste, active:true}

    let disabled = options.disabled || false

    this.generate = () =>{
        button_element.type= 'button'
        updateClass()
        this.updateButton()
        $(container).html(button_element)

        $(button_element).on('click', ()=>{
            let from = getCurrentState()
            toNextState()
            let to = getCurrentState()
            updateClass()
            this.updateButton()
            
            $(document).trigger('toggle_button:click', {fromState: from, toState: to})
            this.trigger('click', {fromState: from, toState: to})
        })
    }
    this.updateButton = _ =>{
        let current_state = getCurrentState()

        $(button_element).html(`${current_state.title} ${((show_icon) ? ' <i class="fas fa-caret-down fa-sm"></i>' : "")}`)

        //limpando classes do elemento
        $(button_element).removeClass('')

        //adicionando tanto a default class quanto as classes do state
        $(button_element).addClass(`${button_class} ${current_state.classList || ""}`)

        button_element.dataset.value = current_state.value

        $(button_element).attr('disabled', disabled)
    }

    this.hide = _ =>{
        $(button_element).css({
            'display': 'none',
            'visibility': 'hidden'
        })
    }

    this.show = _ =>{
        $(button_element).css({
            'display': 'block',
            'visibility': 'visible'
        })
    }

    this.disabled = boolean =>{
        disabled = boolean
        this.updateButton()
    }

    this.getElement = _ =>{
        return button_element
    }

    function toNextState(){
        let index = getCurrentStateIndex()
        states[index].active = false
        if(index != states.length -1){
            states[index+1].active = true
        } else {
            states[0].active = true
        }
    }

    function updateClass(){
        $(button_element).removeClass()
        $(button_element).addClass(button_class)
    }

    function getCurrentState(){
        return states.filter(x=>x.active)[0]
    }

    function getCurrentStateIndex(){
        return states.findIndex(obj => obj.active);
    }
}

ToggleButton.prototype = Object.create(BaseConstructor.prototype)